import { __decorate, __metadata } from "tslib";
import { Component, Prop, Provide } from "vue-property-decorator";
import { UIComponent } from "../UIComponent";
export var LvRadioButtonGroupOrientation;
(function (LvRadioButtonGroupOrientation) {
    LvRadioButtonGroupOrientation["Horizontal"] = "horizontal";
    LvRadioButtonGroupOrientation["Vertical"] = "vertical";
})(LvRadioButtonGroupOrientation || (LvRadioButtonGroupOrientation = {}));
export const SYM_LV_RADIO_BUTTON_GROUP = Symbol("LvRadioButtonGroup");
export const COMPONENT_NAME = "LvRadioButtonGroup";
let LvRadioButtonGroup = class LvRadioButtonGroup extends UIComponent {
    get self() {
        return this;
    }
    get classList() {
        return [
            "lv-radio-button-group",
            this.orientation,
        ];
    }
};
__decorate([
    Provide(SYM_LV_RADIO_BUTTON_GROUP),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], LvRadioButtonGroup.prototype, "self", null);
__decorate([
    Prop({ type: String, required: false, default: () => LvRadioButtonGroupOrientation.Vertical }),
    __metadata("design:type", String)
], LvRadioButtonGroup.prototype, "orientation", void 0);
LvRadioButtonGroup = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvRadioButtonGroup);
export default LvRadioButtonGroup;
//# sourceMappingURL=script.js.map